import { Gallery } from "../../Gallery/Gallery";
import type { FormImage } from "../../ImageInput/useImageInput";

export function CommentFieldGallery({
  images,
  onRemoveImage,
}: {
  images: FormImage[];
  onRemoveImage?: (image: FormImage) => void;
}): React.ReactElement {
  return (
    <figure data-testid="comment-attachment-image-preview">
      <Gallery images={images} onRemove={onRemoveImage} />
    </figure>
  );
}
